import { render } from "./TableDemo.vue?vue&type=template&id=f3b59ba6&scoped=true"
import script from "./TableDemo.vue?vue&type=script&lang=js"
export * from "./TableDemo.vue?vue&type=script&lang=js"

import "./TableDemo.vue?vue&type=style&index=0&id=f3b59ba6&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b59ba6"]])

export default __exports__